import { AnyResource, RelationshipTypeEnum } from "@examspark/types";

import { schemaParams, timestampParams } from "..";

import { AmplifyEnvironment, formatResourceIdFieldValue } from ".";

export const mirroredRelativeTypes = {
  [RelationshipTypeEnum.AlternateParent]: RelationshipTypeEnum.AlternateChild,
  [RelationshipTypeEnum.AlternateChild]: RelationshipTypeEnum.AlternateParent,
  [RelationshipTypeEnum.TranslationParent]:
    RelationshipTypeEnum.TranslationChild,
  [RelationshipTypeEnum.TranslationChild]:
    RelationshipTypeEnum.TranslationParent,
  [RelationshipTypeEnum.Enemy]: RelationshipTypeEnum.Enemy,
};

export const putRelative = async (
  env: AmplifyEnvironment,
  left: AnyResource,
  right: AnyResource,
  rightIsType: RelationshipTypeEnum,
) => {
  const TableName = env.getTableName("resource");
  return env.getDynamoDBDocumentClient().transactWrite({
    TransactItems: [
      {
        Put: {
          TableName,
          Item: {
            id: left.id,
            sk: `relative:${formatResourceIdFieldValue(right)}`,
            relationship: rightIsType,
            workspaceId: left.workspaceId,
            resourceId: formatResourceIdFieldValue(right),
            ...schemaParams(),
            ...timestampParams(),
            __typename: "Resource",
          },
        },
      },
      {
        Put: {
          TableName,
          Item: {
            id: right.id,
            sk: `relative:${formatResourceIdFieldValue(left)}`,
            resourceId: formatResourceIdFieldValue(left),
            workspaceId: left.workspaceId,
            relationship:
              mirroredRelativeTypes[
                rightIsType as keyof typeof mirroredRelativeTypes
              ],
            ...schemaParams(),
            ...timestampParams(),
            __typename: "Resource",
          },
        },
      },
    ],
  });
};

export const deleteRelative = async (
  env: AmplifyEnvironment,
  left: AnyResource,
  right: AnyResource,
  rightIsType: RelationshipTypeEnum,
) => {
  const TableName = env.getTableName("resource");
  return env.getDynamoDBDocumentClient().transactWrite({
    TransactItems: [
      {
        Delete: {
          TableName,
          Key: {
            id: left.id,
            sk: `relative:${formatResourceIdFieldValue(right)}`,
          },
        },
      },
      {
        Delete: {
          TableName,
          Key: {
            id: right.id,
            sk: `relative:${formatResourceIdFieldValue(left)}`,
          },
        },
      },
    ],
  });
};

/**
 * List a asset's `relative:` DDB records. Relatives are things like alternate
 * items, translations, enemies, etc.
 */
export const listRelatives = async (
  env: AmplifyEnvironment,
  resource: AnyResource,
) => {
  const TableName = env.getTableName("resource");
  const { Items } = await env.getDynamoDBDocumentClient().query({
    TableName,
    KeyConditionExpression: "id = :id AND begins_with(sk, :sk)",
    ExpressionAttributeValues: {
      ":id": resource.id,
      ":sk": `relative:`,
    },
  });
  return Items;
};
